<template>
	<div class="view-form-box">
		<div v-if="formData.formDesign.length === 0" class="view-form-box__empty">从左侧拖拽题型入此区域</div>
		<div class="view-form-box__form">
			<draggable class="view-form-box__form__draggable" v-model="formData.formDesign" v-bind="{group: 'view', animation: 200, ghostClass: 'move', handle: '.drag-icon'}" @add="handleAdd">
				<transition-group class="view-form-box__form__draggable__group" :name="formData.formDesign.length ? 'appear' : ''" tag="div">
					<Widget
						v-for="(element, index) in formData.formDesign"
						:key="element.questionCode"
						:formData="formData"
						:element="element"
						:index="index"
						@onChangeFormData="handleFormData" />
				</transition-group>
			</draggable>
		</div>
	</div>
</template>

<script>
import Widget from "./Widget";

export default {
	name: "ViewForm",
	props: ['formData'],
	components: {Widget},
	methods: {
		handleAdd({ newIndex }) {
			this.formData.formSelect = this.formData.formDesign[newIndex];
			this.$emit('onChangeFormData', this.formData);
		},
		handleFormData(data) {
			this.$emit('onChangeFormData', data);
			this.formData = Object.assign(this.formData, data);
		}
	},
};
</script>

<style lang="scss" scoped>
.view-form-box {
	height: 100%;
	position: relative;
	overflow-x: hidden;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
	
	&__empty {
		position: absolute;
        text-align: center;
        width: 300px;
        font-size: 20px;
        top: 200px;
        left: 50%;
        margin-left: -150px;
        color: #ccc;
		letter-spacing: 1px;
	}

	&__form {
		width: 100%;
		height: 100%;

		&.move {
			outline-width: 0;
			height: 3px;
			box-sizing: border-box;
			font-size: 0;
			content: "";
			overflow: hidden;
			padding: 0;
			background: #409eff;
			border: 2px solid #409eff;
		}

		&__draggable {
			width: 100%;
			height: 100%;

			&__group {
				width: 100%;
				min-height: 100%;

				.element-cate-item.move {
					outline-width: 0;
					height: 3px;
					box-sizing: border-box;
					font-size: 0;
					content: "";
					overflow: hidden;
					padding: 0;
					background: #409eff;
					border: 2px solid #409eff;
				}
			}
		}
	}
}
</style>